// extracted by css-extract-rspack-plugin
export default {"cls1":"download_preflight-cls1_N7s","cls2":"download_preflight-cls2_Mpx download_preflight-cls1_N7s"};